export const STATS = {
    init: '',
    pulling: 'pulling',
    enough: 'enough',
    refreshing: 'refreshing',
    refreshed: 'refreshed',
    reset: 'reset',
    error: 'error',
};

export const text = {
    init: '下拉刷新',
    pulling: '下拉刷新',
    enough: '释放刷新',
    refreshing: '刷新中',
    refreshed: '已成功刷新',
    error: '刷新失败',
};
